export default {
  DNSData: {},
};
